import axiosInstance from "./axiosInstance";
import { ENDPOINTS } from "./endpoints";

export const getCdmpOverview = async (locale = "en") => {
  const res = await axiosInstance.get(
    `${ENDPOINTS.CDMP_OVERVIEW}?locale=${locale}`
  );
  console.log("cdmp overview res", res.data?.data);
  return res.data?.data?.[1];
};
